import { useCallback, useEffect } from "react";

import { actions as authenticationActions } from "@/redux/authentication";

import useAppDispatch from "./useAppDispatch";
import { useClerk } from "@clerk/nextjs";

const useResetStoreState = () => {
  const dispatch = useAppDispatch();
  const { signOut } = useClerk();

  const resetAndLogout = useCallback(async () => {
    try {
      // Log out the user using Clerk
      await signOut();
      console.log("User successfully logged out.");
    } catch (error) {
      console.error("Error during Clerk logout:", error);
    }
  }, []);

  useEffect(() => {
    resetAndLogout();
    dispatch(authenticationActions.callSetResetAuthentication());
  }, [dispatch, resetAndLogout]);
};

export default useResetStoreState;
